import { styled, Typography } from '@mui/material';
import { type FC } from 'react';
import { useToggle } from '../../../../../../../../hooks/use-toggle';
import { ControlledTextInput } from '../../../../components/ControlledTextInput';
import { ConfigurationSection } from '../../../../containers/ConfigurationSection';
import { AnrokConfigurationControl, AnrokConfigurationFormValues } from '../../AnrokConfigurationFormSchema';

interface Props {
  defaultValues: AnrokConfigurationFormValues;
  control: AnrokConfigurationControl;
}

export const DefaultProductConfigurationSection: FC<Props> = ({ control, defaultValues }) => {
  const [disabled, toggleDisabled] = useToggle(true);

  return (
    <ConfigurationSection title="Anrok Default Product" iconName="Products">
      <TextInputContainer>
        <TextInputHeaderContainer>
          <Typography
            sx={{
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '12px',
              opacity: disabled ? 0.6 : 1,
            }}
          >
            Default External Product ID
          </Typography>
          <Typography
            sx={{
              color: '#3A78F8',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '12px',
              cursor: 'pointer',
            }}
            onClick={() => toggleDisabled()}
          >
            Modify
          </Typography>
        </TextInputHeaderContainer>
        <ControlledTextInput
          name="defaultExternalProductId"
          control={control}
          disabled={disabled}
          placeholder="Enter Default External Product ID here..."
          defaultValue={defaultValues.defaultExternalProductId}
        />
      </TextInputContainer>
    </ConfigurationSection>
  );
};

const TextInputContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

const TextInputHeaderContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
});
